import { render, staticRenderFns } from "./SellerAccountOffersList.vue?vue&type=template&id=647864be&scoped=true"
import script from "./SellerAccountOffersList.vue?vue&type=script&lang=js"
export * from "./SellerAccountOffersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647864be",
  null
  
)

export default component.exports